import React, { useState } from 'react';
import { Box, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import { Check, ContentCopy } from '@mui/icons-material';

export default function DeletionConfirmation({ kind, expectedValue, value, onChange, disabled = false }: {
  kind: 'study' | 'participant';
  expectedValue: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}) {
  const [copied, setCopied] = useState(false);
  const [copyError, setCopyError] = useState(false);
  const label = kind === 'study' ? 'study name' : 'participant ID';
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(expectedValue);
      setCopied(true);
      setCopyError(false);
    } catch {
      setCopyError(true);
    }
  };
  return <Box sx={{ mt: 3 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1.5, mb: 2, borderRadius: 1, bgcolor: 'action.hover' }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography variant="caption" color="text.secondary">{kind === 'study' ? 'Study name' : 'Participant ID'}</Typography>
        <Typography sx={{ userSelect: 'text', overflowWrap: 'anywhere', whiteSpace: 'pre-wrap', fontWeight: 600 }}>{expectedValue}</Typography>
      </Box>
      <Tooltip title={copied ? 'Copied' : `Copy ${label}`}>
        <IconButton aria-label={`Copy ${label}`} onClick={() => void copy()} disabled={disabled || !expectedValue} size="small">
          {copied ? <Check fontSize="small" /> : <ContentCopy fontSize="small" />}
        </IconButton>
      </Tooltip>
    </Box>
    {copyError && <Typography role="status" variant="body2" sx={{ mb: 2 }}>Could not copy. Select and copy the text above.</Typography>}
    <TextField
      fullWidth
      label={`Enter the ${label} to confirm`}
      value={value}
      onChange={event => onChange(event.target.value)}
      disabled={disabled}
      autoComplete="off"
      inputProps={{ spellCheck: false }}
      helperText="Must match exactly."
    />
  </Box>;
}
